// extracted by mini-css-extract-plugin
module.exports = {"menuItemWrapper":"menu_menuItemWrapper__LWD4c","menuItemText":"menu_menuItemText__z_twB","selectedMenuItemText":"menu_selectedMenuItemText__e5_Ha"};